import clsx from 'clsx';

type CollapserIconProps = {
  show?: boolean;
  onClick?: () => void;
};

export const CollapserIcon: React.FC<CollapserIconProps> = ({
  show,
  onClick,
}) => {
  return (
    <svg
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={clsx('transition-transform', show ? 'rotate-180' : '')}
    >
      <path
        d="M7.49412 0H0.506026C0.100308 0 -0.139562 0.441925 0.0881269 0.768804L3.58217 5.78429C3.78269 6.0719 4.21746 6.0719 4.41797 5.78429L7.91202 0.768804C8.13971 0.441925 7.8989 0 7.49412 0Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};
